module.exports = __webpack_public_path__ + "static/media/group.ac6819ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/group.png
// module id = 347
// module chunks = 0